














































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
import edit from './AgentsEdit.vue';
import AgentBalanceAdjustOrderEdit from '@/views/AgentManage/AgentBalanceAdjustOrder/AgentBalanceAdjustOrderEdit.vue'
import AgentStatistics from '@/views/AgentManage/Agents/AgentStatistics.vue'
@Component({
    components: { edit, AgentBalanceAdjustOrderEdit,AgentStatistics }
})
export default class suppliermanage extends pagelist {
    get prox() {
        return new proxy.AgentServiceProxy();
    }
    input: proxy.AgentPageInputDto = new proxy.AgentPageInputDto();
    total = new proxy.AgentTotalOutDto();
    sub_id = 0;
    AgentStatisticsShow = false;
    createOrEditShow = false;
    agentId = 0;
    AgentBalanceAdjustOrderEditshow = false;
    columns = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },
        {
            title: '名称',
            slot: 'name'
        },
        {
            title: '编号',
            key: 'aCode'
        },
        {
            title: '登录账号',
            key: 'userName'
        },
        {
            title: '余额',
            slot: 'balance'
        },

        {
            title: '状态',
            slot: 'status',
            width: 100
        },

        {
            title: '提现服务费',
            slot: 'withdrawMethod',
            width: 250
        },
        {
            title: '创建时间',
            key: 'creationTime'
        },
        {
            title: '操作',
            slot: 'oper'
        }
    ];
    actionclick(row, e) {
        if (e == 1) {
            this.del(row);
        }
        if (e == 2) {
            this.$Modal.confirm({
                title: '你确定重置登录密码吗?重置后密码为:123456',
                onOk: () => {
                    new proxy.UserManageServiceProxy().resetLoginPwd(row.userId).then(x => {
                        this.$Notice.success({ title: '重置成功' });
                        this.getpage();
                    })
                }
            });

        }
        if (e == 3) {
            this.$Modal.confirm({
                title: '你确定要清除该用户绑定的谷歌验证吗?',
                onOk: () => {
                    new proxy.UserManageServiceProxy().clearGoogleKey(row.userId).then(x => {
                        this.$Notice.success({ title: '清除成功' });
                        this.getpage();
                    })
                }
            });
        }
        if (e == 4) {
            new proxy.UserManageServiceProxy().unlockUser(row.userId).then(x => {
                this.$Modal.success({
                title: '解除锁定',
                content: '解除成功，请尝试重新登录'
                })
            })
        }
    }
    showAgentStatistics(id) {
        
    this.sub_id = id;
    this.AgentStatisticsShow = true
  }
    adjbalance(row) {
        this.agentId = row.id;
        this.AgentBalanceAdjustOrderEditshow = true;
    }
    statuschange(row, e) {
        if (e) {
            row.status = 0;
        } else {
            row.status = 1
        }
        this.prox.createOrUpdate(row).then(x => {
            this.$Notice.success({ title: '修改成功' });
            this.getpage();
        })
    }

    fetchDataList(
        request: PagedFilterAndSortedRequest,
        pageNumber: number,
        finishedCallback: Function
    ): void {
        this.input.skipCount = request.skipCount;
        this.input.maxResultCount = request.maxResultCount;
        this.input.sorting = request.sorting;
        console.log(request.skipCount);
        this.prox.queryModelList(this.input).then(x => {
            this.dataList = x.items;
            this.showPaging(x);
        });
        this.prox.queryTotalBalance(this.input).then((x) => {
        this.total = x;
    });
    }

    getpage() {
        this.OnInit();
    }
    async created() {
        this.getpage();
    }
    create() {
        this.createOrEditShow = true;
        this.sub_id = undefined;
    }
    edit(row) {
        if (!row) {
            if (this.selectedDataItems.length == 0) {
                this.$Notice.error({ title: '请选中一条数据' });
                return;
            }
            row = this.selectedDataItems[0];
        }
        this.sub_id = row.id;
        this.createOrEditShow = true;
    }

    del(row) {

        this.$Modal.confirm({
            title: '你确定要删除吗?删除后将无法恢复',
            onOk: () => {

                this.prox.deletes([row.id]).then(() => {
                    this.$Notice.success({ title: '删除成功' });
                    this.getpage();
                });
            }
        });
    }
}
